import React from "react";
import "./Siaphuni.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Surroundingimages from "../../Media/Siap Huni/Siaphuni";

const settings1 = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6283899578378&text=Halo%20Tari,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Harapan%20Indah%20(Rumah%20Siap%20Huni)%20https://kotaharapanindahmarketing.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="siaphuni" className="surrounding">
      <div className="slider-regia">
        <Slider {...settings1}>
          {Surroundingimages.map((image, index) => (
            <img className="imagecard" key={index} src={image} alt={image} />
          ))}
        </Slider>
      </div>
      <div className="container-fasilitas">
        <h1>Gallery Siap Huni Kota Harapan Indah</h1>
        <hr color="white" />
        <div className="container-desk">
          <div className="desksurrounding">
            Berikut adalah pilihan beberapa cluster yang sudah siap huni di
            kawasan Kota harapan indah :
          </div>
        </div>
        <div className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Cluster Tera Damai
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Elora</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Kana</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Albasia</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Cluster Asera Nishi
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Lavesh</span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Nismara</span>
            </div>

            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>
                &nbsp;&nbsp;Cluster Asia Tropis
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="rgb(200, 169, 92)" />
              <span style={{color: "white"}}>&nbsp;&nbsp;Cluster Greenara</span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
